import { Component, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { ApiGatewayService } from 'src/app/services/api-gateway.service';
import { InfoMessageService, emitInfoMessage } from 'src/app/services/info-message.service';

export interface ConnectorWithStatus {
  name: string;
  display_name: string;
  status: string;
  minutesSinceUpdate: number;
}

@Component({
    selector: 'tab-system-status',
    templateUrl: './tab-system-status.component.html',
    standalone: false
})
export class TabSystemStatusComponent implements OnInit {
  connectorsWithStatus: ConnectorWithStatus[] = [];
  selectedConnectorWithStatus?: ConnectorWithStatus;
  statussesWithIssues: number = 0;
  subscription: Subscription;
  minuteTimerSubscription: Subscription;

  constructor(private infoMessageService: InfoMessageService,
              private gatewayApiService: ApiGatewayService){
                const fiveMinuteTimer = interval(5*60*1000); // 5 minutes
                this.subscription = fiveMinuteTimer.subscribe(e => this.getConnectorsStatusses());

                const oneMinuteTimer = interval(60*1000); // 1 minute
                this.minuteTimerSubscription = oneMinuteTimer.subscribe(() => {
                  this.connectorsWithStatus.forEach(connector => {
                    connector.minutesSinceUpdate++;
                  });
                });
              }

  async ngOnInit(){
    await this.getConnectors();
    await this.getConnectorsStatusses();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.minuteTimerSubscription.unsubscribe();
  }

  async getConnectors(){
    // get connectors
    await this.gatewayApiService.getConnectors()
      .then( (data) => {
        data.body?.forEach( (connector) => {
        this.connectorsWithStatus.push(
          { name: connector.name,
            display_name: connector.display_name,
            status: 'unknown',
            minutesSinceUpdate: 0}
          );
        });
      })
      .catch( (error) => {
        emitInfoMessage(error.status +": "+ error.statusText, this.infoMessageService)
      })
  }

  async getConnectorsStatusses(){
    // get statusses
    this.connectorsWithStatus.forEach( async (connector) => {
      await this.gatewayApiService.getConnectorStatus(connector.name)
        .then((data) => {
          if (data.body) {
            connector.status = data.body.state;
            connector.minutesSinceUpdate = 0;
          }
        })
        .catch((error) => {
          emitInfoMessage(error.status +": "+ error.statusText, this.infoMessageService)
        })
    })
  }

  selectStatus(status : ConnectorWithStatus){
    if (status == this.selectedConnectorWithStatus){
      this.selectedConnectorWithStatus = undefined;
    } else {
      this.selectedConnectorWithStatus = status;
    }
  }

  getStatusClass(status: string): string {
    if(status == null){
      return ''
    }
    switch(status.toLowerCase()) {
      case 'empty':
        return 'bg-[#63E2BE]';
      case 'busy':
        return 'bg-[#FFE252]';
      case 'blocked':
        return 'bg-[#C84143]';
      case 'unknown':
      default:
        return '';
    }
  }

  getStatusMessage(status: string): string {
    if(status == null){
      return 'unknown'
    }
    switch(status.toLowerCase()) {
      case 'empty':
        return 'synchronised';
      default:
        return status.toLowerCase();
    }
  }

  getQueueMessage(status: string): string {
    if(status == null){
      return 'Status of connector is unknown.'
    }
    switch(status.toLowerCase()) {
      case 'empty':
        return 'All data transferred.';
      case 'busy':
        return 'Some packets are in the queue.';
      case 'blocked':
        return 'Many packets are in the queue.';
      case 'unknown':
        return 'Status of connector is unknown.'
      default:
        return '';
    }
  }

  getTimeAgo(minutes: number): string {
    if (minutes === 0) {
      return 'just now';
    } else {
      return `${minutes} min ago`;
    }
  }
}
